import {
    Background,
    BackgroundColor,
    Container,
    Grid,
    GridColumns,
    GridGap,
    Spacer,
    SpacerVariant,
    backgroundOptions,
    spacerOptions,
} from "../../components/layout"
import { Color, TypographyColor } from "../../components/typography"
import { Repeater, types } from "react-bricks/frontend"

import { CenterTextProps } from "../../text/CenterText"
import React from "react"

interface TwoColumnImageTextProps {
    background: { color: BackgroundColor } | BackgroundColor
    spacerTop: boolean
    spacerBottom: boolean
    variantTop?: SpacerVariant
    variantBottom?: SpacerVariant
}

const TwoColumnImageText: types.Brick<TwoColumnImageTextProps> = ({
    background,
    spacerTop,
    spacerBottom,
    variantTop,
    variantBottom,
}) => {
    const bgColor = typeof background === "object" ? background.color : background

    return (
        <Background color={bgColor}>
            <Container>
                <Spacer variant={!spacerTop ? SpacerVariant.None : variantTop} />
                <Color
                    color={
                        bgColor === BackgroundColor.Green || bgColor === BackgroundColor.DarkBlumine
                            ? TypographyColor.White
                            : TypographyColor.Darkgrey
                    }
                >
                    <Repeater
                        propName="centerText"
                        itemProps={
                            {
                                color:
                                    bgColor === BackgroundColor.Green || bgColor === BackgroundColor.DarkBlumine
                                        ? TypographyColor.White
                                        : TypographyColor.Darkgrey,
                            } as CenterTextProps
                        }
                    />
                    <Grid columns={GridColumns.Two} gapY={GridGap.Large} as="ul">
                        <Repeater propName="repeater" itemProps={{ bgColor: bgColor }} />
                    </Grid>
                </Color>
                <Spacer variant={!spacerBottom ? SpacerVariant.None : variantBottom} />
            </Container>
        </Background>
    )
}

TwoColumnImageText.schema = {
    name: "TwoColumnImageText",
    label: "Image Text (2 Col)",
    previewImageUrl: `${process.env.IMG_CDN_URL_ASSETS}/lavita.de/startseite/screenshots_bricks/2ColumnImageText.png`,
    repeaterItems: [
        {
            name: "repeater",
            items: [
                {
                    type: "TwoColumnImageTextItem",
                    label: "Image Text Item",
                    min: 1,
                },
            ],
        },
        {
            name: "centerText",
            items: [
                {
                    type: "CenterText",
                    label: "Text",
                    max: 1,
                },
            ],
        },
    ],
    sideEditProps: [
        {
            name: "background",
            label: "Background",
            type: types.SideEditPropType.Select,
            selectOptions: {
                options: backgroundOptions,
                display: types.OptionsDisplay.Color,
            },
        },
        {
            groupName: "Spacer",
            props: [
                {
                    name: "spacerTop",
                    label: "Spacer Top",
                    type: types.SideEditPropType.Boolean,
                },
                {
                    name: "variantTop",
                    label: "Spacer Variant",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptions,
                        display: types.OptionsDisplay.Select,
                    },
                    show: props => props.spacerTop === true,
                },
                {
                    name: "spacerBottom",
                    label: "Spacer Bottom",
                    type: types.SideEditPropType.Boolean,
                },
                {
                    name: "variantBottom",
                    label: "Spacer Variant",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptions,
                        display: types.OptionsDisplay.Select,
                    },
                    show: props => props.spacerBottom === true,
                },
            ],
        },
    ],
    getDefaultProps: (): TwoColumnImageTextProps => ({
        background: { color: BackgroundColor.White },
        spacerTop: true,
        spacerBottom: true,
        variantTop: SpacerVariant.Base,
        variantBottom: SpacerVariant.Base,
    }),
}

export default TwoColumnImageText
